var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelect = function SvgSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.872.817c.256.223.283.61.06.867L8.546 14.79a.615.615 0 0 1-.895.034L1.016 8.271a.614.614 0 1 1 .863-.874l6.17 6.093L19.004.878a.614.614 0 0 1 .867-.06Z",
    fill: "#0058AA",
    stroke: "#0058AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgSelect as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS44NzE2IDAuODE3MDg3QzIwLjEyNzcgMS4wMzk2MSAyMC4xNTQ5IDEuNDI3NjUgMTkuOTMyNCAxLjY4Mzc5TDguNTQ2MjYgMTQuNzkwMkM4LjQzNDkzIDE0LjkxODMgOC4yNzU1NCAxNC45OTQ3IDguMTA1OTEgMTUuMDAxMkM3LjkzNjI5IDE1LjAwNzYgNy43NzE1NCAxNC45NDM2IDcuNjUwNzYgMTQuODI0NEwxLjAxNTY2IDguMjcxMTdDMC43NzQyNDggOC4wMzI3NCAwLjc3MTgzMiA3LjY0Mzc2IDEuMDEwMjYgNy40MDIzNUMxLjI0ODY5IDcuMTYwOTQgMS42Mzc2NyA3LjE1ODUyIDEuODc5MDggNy4zOTY5NUw4LjA0ODIxIDEzLjQ4OTlMMTkuMDA0OCAwLjg3Nzk1OUMxOS4yMjc0IDAuNjIxODE2IDE5LjYxNTQgMC41OTQ1NjMgMTkuODcxNiAwLjgxNzA4N1oiIGZpbGw9IiMwMDU4QUEiIHN0cm9rZT0iIzAwNThBQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";